import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const loadSeo = () => (cache ||= api.get("/seo").then(r => Object.fromEntries(r.data.map(p => [p.page_key, p]))).catch(() => ({})));

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

export default function Seo({ page, title, description }) {
  const [pages, setPages] = useState(null);
  useEffect(() => { loadSeo().then(setPages); }, []);
  useEffect(() => {
    const p = (pages && page && pages[page]) || {};
    const t = title || p.title || "REXTECH IT SOLUTION";
    document.title = t;
    setMeta("description", description || p.description || "");
    if (p.keywords) setMeta("keywords", p.keywords);
  }, [pages, page, title, description]);
  return null;
}
